import {
    CloseButton,
    DialogBackdrop,
    DialogContent,
    DialogHeader,
    DialogPositioner,
    DialogRoot,
    DialogTitle,
    Flex,
    Portal
} from "@chakra-ui/react"

export default function Dialog(
    {
        children, title, loading = false, onClose = () => {
    }, ...props
    }
) {
    return (
        <DialogRoot
            onInteractOutside={onClose}
            onEscapeKeyDown={onClose}
            closeOnInteractOutside={!loading}
            motionPreset="slide-in-top" {...props}
        >
            <Portal>
                <DialogBackdrop/>
                <DialogPositioner>
                    <DialogContent>
                        <DialogHeader px={6} py={4}>
                            <Flex alignItems="center" justify="space-between">
                                <DialogTitle>{title}</DialogTitle>

                                <CloseButton
                                    position="absolute"
                                    right="16px"
                                    disabled={loading}
                                    onClick={!loading ? onClose : null}
                                />
                            </Flex>
                        </DialogHeader>
                        {children}
                    </DialogContent>
                </DialogPositioner>
            </Portal>
        </DialogRoot>
    )
}